import { type ReactNode } from 'react';
import { Alert } from '~/molecules';

type P = {
  /** Applied to the built-in `Alert`; ignored once a custom renderer takes over. */
  readonly className?: string;
  readonly error: Error;
  /**
   * Renders app-specific error UI (e.g. an HTTP validation alert) instead of
   * the built-in message. Invoked from this component's own render, so a
   * surrounding `ErrorBoundary` catches a callback that throws.
   */
  readonly renderSubmitError?: (error: Error) => ReactNode;
};

export function SubmitErrorRenderer({
  className,
  error,
  renderSubmitError,
}: P) {
  return renderSubmitError ? (
    <>{renderSubmitError(error)}</>
  ) : (
    <Alert className={className} severity="error">
      {error.message}
    </Alert>
  );
}
